import { render, staticRenderFns } from "./CollectionSelect_1.vue?vue&type=template&id=16b995c4&scoped=true&"
import script from "./CollectionSelect_1.vue?vue&type=script&lang=js&"
export * from "./CollectionSelect_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b995c4",
  null
  
)

export default component.exports